export default class Role {
    constructor (json) {
        this.id = 0;
        this.name = "";
        this.isActive = true;
        this.isAdmin = false;
        this.isDefault = false;

        if (json)
            mapRoleToJson(json, this);
    }
}

const mapRoleToJson = (json, role) => {
    role.isActive = json.IsActive;
    role.isAdmin = json.IsAdmin;
    role.id = json.Id;
    role.isDefault = json.IsDefault;
    role.name = json.Name;
};

